/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Content_BodyInputs */

const tr_mesafeli_s3_content_body = /** @type {(inputs: Mesafeli_S3_Content_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri tarafından Platform'a yüklenen veya Platform aracılığıyla işlenen tüm veri (ürün, sipariş, fatura, müşteri kaydı vb.).`)
};

const en_mesafeli_s3_content_body = /** @type {(inputs: Mesafeli_S3_Content_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All data uploaded to the Platform by the Customer or processed through the Platform (product, order, invoice, customer record, etc.).`)
};

const de_mesafeli_s3_content_body = /** @type {(inputs: Mesafeli_S3_Content_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Daten, die vom Kunden auf die Plattform hochgeladen oder über die Plattform verarbeitet werden (Produkt, Bestellung, Rechnung, Kundendatensatz usw.).`)
};

const ru_mesafeli_s3_content_body = /** @type {(inputs: Mesafeli_S3_Content_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все данные, загружаемые Клиентом на Платформу или обрабатываемые через Платформу (товар, заказ, счёт, запись о клиенте и т. п.).`)
};

/**
* | output |
* | --- |
* | "All data uploaded to the Platform by the Customer or processed through the Platform (product, order, invoice, customer record, etc.)." |
*
* @param {Mesafeli_S3_Content_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_content_body = /** @type {((inputs?: Mesafeli_S3_Content_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Content_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_content_body(inputs)
	if (locale === "de") return de_mesafeli_s3_content_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_content_body(inputs)
	return tr_mesafeli_s3_content_body(inputs)
});